// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { useTranslation } from 'react-i18next';

interface SelectedToolProps {
  toolName: string;
  onRemove: () => void;
}

const SelectedTool: React.FC<SelectedToolProps> = ({ toolName, onRemove }) => {
  const { t } = useTranslation();
  return (
    <span
      id="id-selected-tool-container"
      data-testid="selected-tool-container"
      className="inline-flex items-center rounded bg-blue-50 px-1.5 py-0.5 dark:bg-blue-950"
    >
      <span
        id="id-selected-tool-text"
        data-testid="selected-tool-text"
        className="font-medium text-blue-800 dark:text-blue-200"
      >
        {toolName}
      </span>
      <button
        type="button"
        onClick={onRemove}
        className="ml-1 cursor-pointer border-0 bg-transparent text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-200"
        aria-label={t('remove-tool', { toolName })}
        title={t('remove-tool', { toolName })}
      >
        ×
      </button>
    </span>
  );
};

export default SelectedTool;
